export default class AdminDashboard {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  /** Admin Dashboard */
  fetchStats(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminDashboardEndpoint}/stats`, {
      params
    })
  }

  fetchGraph(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminDashboardEndpoint}/graph`, {
      params
    })
  }

  fetchPartnersGraph(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminDashboardEndpoint}/partners-graph`, {
      params
    })
  }

  /** Tags */
  fetchNavigationTagsData(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminDashboardEndpoint}/tags`, {
      params
    })
  }
}
